import React from 'react';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import {bindActionCreators} from 'redux';
import withProps from 'recompose/withProps';
import setDisplayName from 'recompose/setDisplayName';
import DropdownInput from 'components/forms/BasicFormFields/DropdownInput';
import {FormattedMessage} from 'react-intl';
import {Form, Dropdown, Label} from 'semantic-ui-react';
import {setNgcEndpointAction} from '../actions';

const mapStateToProps = state => {
  const {ngcEndpointList, ngcEndpoint} = state.rewards;

  let options = [];

  options = ngcEndpointList.map(endpoint => ({
    text: endpoint.label,
    value : endpoint.id
  }));

  return {
    options
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
    setNgcEndpoint: setNgcEndpointAction
  }, dispatch);


class NgcEndpointDropdown extends React.Component {
  
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (event, sender) => {
    this.props.onValueChanged(sender.value);
    this.props.setNgcEndpoint(sender.value);
  }

  render() {

    return (
      <Form.Field>
        {this.props.label}
        <Dropdown
          text={this.props.text}
          options={this.props.options}
          value={this.props.value}
          onChange={this.handleChange}
          fluid
          selection
          closeOnBlur
          closeOnChange
          openOnFocus={false}
          selectOnBlur={false} />
    </Form.Field>

    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NgcEndpointDropdown); 



// WEBPACK FOOTER //
// ./public/pages/Rewards/RetailerItemModal/NgcEndpointDropdown.jsx